/* Struxa build-code grammar, shared by any page that has to read or write a
   build code like B-330-75-1-1A.

     B    shaft diameter letter (A=6mm, B=8mm, C=10mm, D=12mm)
     330  installation length in mm
     75   force in newtons, divided by 10
     1    shaft-end fitting code ("1A" = that fitting plus a 10mm ball stud)
     1A   body/tube-end fitting code

   The tables below are copied verbatim from assets/gas-struts-catalogue.js,
   which still carries its own private copy - that page's builder is wired
   through per-card state and could not be pulled apart without rewriting the
   live catalogue. If a fitting code, name or render bucket changes, it has to
   change in BOTH files. New pages should use this module. */
(function(){
  var R2 = 'https://pub-38cb3bf26b2c46dbb6eb7d17f61c0227.r2.dev';

  var SHAFT_LETTER = { 6:'A', 8:'B', 10:'C', 12:'D' };

  /* M8 Thread is withdrawn as a CHOICE (Dave, 2026-09-01) but stays in the
     table so an older code carrying a '0' segment still resolves to a name.
     `hidden` is what keeps it out of every <select>. */
  var FIT_OPTIONS = [
    { id:'h6',     code:'1', ballCode:'1A', name:'Standard Plastic Socket 10mm', desc:'Nylon socket · clips onto a 10mm ball stud', studCompatible:true },
    { id:'h2a',    code:'2', ballCode:'2A', name:'Angled Plastic Socket 10mm',   desc:'Nylon, angled · clips onto a 10mm ball stud', studCompatible:true },
    { id:'f6sp',   code:'3', ballCode:'3A', name:'Small Plastic Socket 10mm',    desc:'Nylon, compact · clips onto a 10mm ball stud', studCompatible:true },
    { id:'f7',     code:'4', ballCode:'4A', name:'Metal Ball Socket 10mm',       desc:'Steel socket · clips onto a 10mm ball stud', studCompatible:true },
    { id:'thread', code:'0', ballCode:null, name:'M8 Thread',                    desc:'Bare M8 thread · screws into your own fitting, no socket', studCompatible:false, hidden:true },
    { id:'eye',    code:'5', ballCode:null, name:'Metal Eye End M8',             desc:'Steel eye, 8mm pin hole · bolts through, no ball stud', studCompatible:false }
  ];
  var FIT_CHOICES = FIT_OPTIONS.filter(function(f){ return !f.hidden; });
  var FIT_MAP = {};
  FIT_OPTIONS.forEach(function(f){ FIT_MAP[f.id] = f; });

  var BALL_STUD_NOTE = 'A ball stud is the 10mm ball-shaped pin bolted to the vehicle. The socket clips over it - if your old strut pops off a little ball, that is what you have.';

  var BUCKET_TUBE = {
    h6:     'Standard plastic 10mm socket tube',
    h2a:    'Angled plastic socket 10mm tube',
    f6sp:   'Small plastic socket 10mm tube',
    f7:     'Metal Socket 10mm tube',
    thread: '8mm thread tube',
    eye:    '8mm metal eye tube'
  };
  var BUCKET_SHAFT = {
    h6:     'Standard plastic 10mm socket shaft',
    h2a:    'Angled plastic socket 10mm shaft',
    f6sp:   'Small plastic socket 10mm shaft',
    f7:     'Metal socket 10mm shaft',
    thread: '8mm thread shaft',
    eye:    '8mm metal eye shaft'
  };
  var BUCKET_SHAFT_BALL = {
    h6:     'Standard plastic socket 10mm shaft ball stud',
    h2a:    'Angled plastic socket 10mm shaft ball stud',
    f6sp:   'Small plastic socket 10mm ball stud shaft',
    f7:     'Metal socket 10mm ball stud shaft'
  };
  var BUCKET_TUBE_BALL = {
    h6:     'Standard plastic socket 10mm tube ball stud',
    h2a:    'Angled plastic socket 10mm tube ball stud',
    f6sp:   'Small plastic socket 10mm ball stud tube',
    f7:     'Metal socket 10mm ball stud tube'
  };

  function fitName(id){
    var f = FIT_MAP[id];
    return f ? f.name : id;
  }

  function fitCode(id, hasBall){
    var f = FIT_MAP[id];
    if(!f || !f.code) return null;
    if(hasBall && f.studCompatible && f.ballCode) return f.ballCode;
    return f.code;
  }

  /* When both ends match, one fitting name. When they differ, BOTH ends are
     named rather than collapsing to a vague "Custom" string that hides the
     actual selections from the cart, checkout and packing slip. */
  function buildFitLabel(shaftFitId, shaftBall, bodyFitId, bodyBall){
    if(shaftFitId === bodyFitId && shaftBall === bodyBall){
      /* " (both ends)" matches the dropdown the customer actually chose from -
         the option text carries that suffix and this label used to drop it, so
         the cart, the checkout, the confirmation email and the tax invoice all
         described a two-ended part with one unqualified name. */
      return fitName(shaftFitId) + (shaftBall ? ' + ball stud' : '') + ' (both ends)';
    }
    return 'Shaft end: ' + fitName(shaftFitId) + (shaftBall ? ' + ball stud' : '') +
      ' / Body end: ' + fitName(bodyFitId) + (bodyBall ? ' + ball stud' : '');
  }

  function buildCode(diam, len, force, shaftFitId, shaftBall, bodyFitId, bodyBall){
    var letter = SHAFT_LETTER[diam] || '?';
    var base = letter + '-' + len + '-' + Math.round(force / 10);
    var sCode = fitCode(shaftFitId, shaftBall);
    var bCode = fitCode(bodyFitId, bodyBall);
    if(!sCode || !bCode) return null;
    return base + '-' + sCode + '-' + bCode;
  }

  function parseCode(code){
    if(!code) return null;
    var m = /^([A-D])-(\d{2,4})-(\d{1,3})-(\d[A]?)-(\d[A]?)$/i.exec(String(code).trim().toUpperCase());
    if(!m) return null;
    var letter = m[1], len = parseInt(m[2], 10), force = parseInt(m[3], 10) * 10;
    var diam = null;
    Object.keys(SHAFT_LETTER).forEach(function(d){ if(SHAFT_LETTER[d] === letter) diam = parseInt(d, 10); });
    if(!diam) return null;
    function resolveFit(token){
      var hasBall = /A$/.test(token);
      var numCode = token.replace('A', '');
      var match = null;
      FIT_OPTIONS.forEach(function(f){
        if(token === f.ballCode || (!hasBall && numCode === f.code)) match = f;
      });
      if(!match) return null;
      return { id: match.id, ball: hasBall && !!match.ballCode };
    }
    var shaft = resolveFit(m[4]);
    var body = resolveFit(m[5]);
    if(!shaft || !body) return null;
    return { diam: diam, len: len, force: force, shaftFit: shaft.id, shaftBall: shaft.ball, bodyFit: body.id, bodyBall: body.ball };
  }

  function compositeUrl(shaftFitId, bodyFitId, shaftBall, bodyBall){
    var shaftName = (shaftBall && BUCKET_SHAFT_BALL[shaftFitId]) ? BUCKET_SHAFT_BALL[shaftFitId] : BUCKET_SHAFT[shaftFitId];
    var tubeName  = (bodyBall && BUCKET_TUBE_BALL[bodyFitId]) ? BUCKET_TUBE_BALL[bodyFitId] : BUCKET_TUBE[bodyFitId];
    return R2 + '/' + encodeURIComponent(shaftName) + '__' + encodeURIComponent(tubeName) + '.png';
  }

  function forceToLbs(n){ return Math.round(n * 0.2248); }
  function forceToKg(n){ return Math.round(n / 10); }

  window.StruxaStrutCode = {
    SHAFT_LETTER: SHAFT_LETTER,
    FIT_OPTIONS: FIT_OPTIONS,
    FIT_CHOICES: FIT_CHOICES,
    FIT_MAP: FIT_MAP,
    BALL_STUD_NOTE: BALL_STUD_NOTE,
    fitName: fitName,
    fitCode: fitCode,
    buildFitLabel: buildFitLabel,
    buildCode: buildCode,
    parseCode: parseCode,
    compositeUrl: compositeUrl,
    forceToLbs: forceToLbs,
    forceToKg: forceToKg
  };
})();
